import { appConfig } from 'src/config/app-config'

export const SENTRY_CONFIG = {
  DSN: appConfig.sentryDsn,
  ALLOW_ORIGIN: ['localhost', /^https:\/\/v-comply\.com/],
  TRACES_SAMPLE_RATE: 1.0,
  REPLAY_SESSION_SAMPLE_RATE: 0.1,
  REPLAY_ON_ERROR_SAMPLE_RATE: 1.0,
};
